import { cn } from "../../../utils/useFunctions";

const ViewTableFamilyInsurance = ({ className, data }) => {
  const tempData = [
    {
      name: data?.beneficiary_name_one || "-",
      relation: data?.beneficiary_relationship_one || "-",
    },
    {
      name: data?.beneficiary_name_two || "-",
      relation: data?.beneficiary_relationship_two || "-",
    },
  ];

  return (
    <div className="w-full">
      <div
        className={cn(
          "bg-maincyan/10 mb-1 grid grid-cols-2 text-mainblue text-[12px] font-[500] p-2 rounded-[5px] w-full",
          className
        )}
      >
        <div className="text-center">ชื่อ-นามสกุล</div>
        <div className="text-center">ความสัมพันธ์</div>
      </div>
      {tempData.map((educationItem, index) => {
        return (
          <div
            key={index}
            className={cn(
              "bg-[#f9f9f9] grid grid-cols-2 text-mainblue text-[12px] font-[500] p-2 rounded-b-[5px] ",
              className
            )}
          >
            <div className="text-center">{educationItem?.name}</div>
            <div className="text-center">{educationItem?.relation}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ViewTableFamilyInsurance;
